function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import * as t from 'type-shift';
export var useDebounce = function useDebounce(_ref) {
  var value = _ref.value,
      _ref$debounce = _ref.debounce,
      debounce = _ref$debounce === void 0 ? 200 : _ref$debounce,
      _ref$convert = _ref.convert,
      convert = _ref$convert === void 0 ? t.optional(t.string) : _ref$convert,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur;

  // Keep track of the focused state
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1]; // Current value of the field


  var _useState3 = useState(value),
      _useState4 = _slicedToArray(_useState3, 2),
      currentValue = _useState4[0],
      setCurrentValue = _useState4[1]; // Previous value of the field


  var _useState5 = useState(value),
      _useState6 = _slicedToArray(_useState5, 2),
      previousValue = _useState6[0],
      setPreviousValue = _useState6[1]; // References to the timer triggered for debouncing


  var debounceTimer = useRef(); // Trigger an onChange event based on the current value

  var propagateInternalChanges = useCallback(function () {
    if (currentValue !== previousValue) {
      if (onChange) {
        onChange(currentValue, previousValue);
      }

      setPreviousValue(currentValue);
    }
  }, [currentValue, onChange, previousValue, setPreviousValue]); // Use an effect to trigger the debounce timer, preventing
  //   the onChange events from being triggered until the user
  //   stops typing.

  useEffect(function () {
    debounceTimer.current = setTimeout(function () {
      propagateInternalChanges();
    }, debounce); // Clear the timer on re-render

    return function () {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, [debounce, debounceTimer, propagateInternalChanges]); // Effect to set the value of the field from props if it is not
  //   focused.

  useEffect(function () {
    if (!focused && value !== currentValue) {
      setPreviousValue(currentValue);
      setCurrentValue(value);
    }
  }, [currentValue, focused, setCurrentValue, setPreviousValue, value]); // Memoize the wrapped onChange method

  var wrappedOnChange = useCallback(function (newValue) {
    setCurrentValue(convert(newValue.target.value));
  }, [convert, setCurrentValue]); // Memoize the wrapped onFocus method

  var wrappedOnFocus = useCallback(function (evt) {
    // Set focus state and call defined onFocus (if any)
    setFocused(true);

    if (onFocus) {
      onFocus(evt);
    }
  }, [onFocus, setFocused]); // Memoize the wrapped onBlur method

  var wrappedOnBlur = useCallback(function (evt) {
    // Immediately propagate changes
    propagateInternalChanges(); // Set focus state and call defined onBlur (if any)

    setFocused(false);

    if (onBlur) {
      onBlur(evt);
    }
  }, [onBlur, propagateInternalChanges, setFocused]); // Memoize the output

  return useMemo(function () {
    return {
      onBlur: wrappedOnBlur,
      onChange: wrappedOnChange,
      onFocus: wrappedOnFocus,
      value: currentValue === undefined ? '' : currentValue
    };
  }, [currentValue, wrappedOnBlur, wrappedOnChange, wrappedOnFocus]);
};